module.exports = __webpack_public_path__ + "static/media/philanthropist-badge.6e89eb94.svg";